export default function ReportsPanel({ reports }) {
  if (!reports) {
    return (
      <div className="retro-panel text-center py-12">
        <div className="text-2xl glow-text" style={{ color: '#FF6B00' }}>
          [LOADING REPORTS...]
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Summary Stats */}
      <div className="retro-panel">
        <h2 className="text-3xl font-bold mb-6 glow-text" style={{ color: '#FF6B00', fontFamily: 'Orbitron, sans-serif' }}>
          [WORK SUMMARY REPORT]
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="border-2 p-4" style={{ borderColor: '#FF6B00', boxShadow: '0 0 10px rgba(255, 107, 0, 0.3)' }}>
            <div className="text-sm font-semibold" style={{ color: '#ffffff' }}>
              TOTAL ENTRIES
            </div>
            <div className="text-4xl font-bold mt-2 glow-text" style={{ color: '#FF6B00' }}>
              {reports.total_entries}
            </div>
          </div>

          <div className="border-2 p-4" style={{ borderColor: '#FF6B00', boxShadow: '0 0 10px rgba(255, 107, 0, 0.3)' }}>
            <div className="text-sm font-semibold" style={{ color: '#ffffff' }}>
              TOTAL HOURS
            </div>
            <div className="text-4xl font-bold mt-2 glow-text" style={{ color: '#FF6B00' }}>
              {reports.total_hours.toFixed(1)}
            </div>
          </div>

          <div className="border-2 p-4" style={{ borderColor: '#ffffff', boxShadow: '0 0 10px rgba(255, 255, 255, 0.3)' }}>
            <div className="text-sm font-semibold" style={{ color: '#ffffff' }}>
              REMOTE WORK
            </div>
            <div className="text-4xl font-bold mt-2 glow-text" style={{ color: '#ffffff' }}>
              {reports.remote_count}
            </div>
          </div>

          <div className="border-2 p-4" style={{ borderColor: '#ffffff', boxShadow: '0 0 10px rgba(255, 255, 255, 0.3)' }}>
            <div className="text-sm font-semibold" style={{ color: '#ffffff' }}>
              ON-SITE WORK
            </div>
            <div className="text-4xl font-bold mt-2 glow-text" style={{ color: '#FF6B00' }}>
              {reports.onsite_count}
            </div>
          </div>
        </div>
      </div>

      {/* Hours by Customer */}
      <div className="retro-panel">
        <h2 className="text-3xl font-bold mb-6 glow-text" style={{ color: '#FF6B00', fontFamily: 'Orbitron, sans-serif' }}>
          [HOURS BY CUSTOMER]
        </h2>

        <div className="space-y-4">
          {Object.entries(reports.customer_hours).length === 0 ? (
            <div className="text-xl" style={{ color: '#ffffff' }}>
              [NO DATA AVAILABLE]
            </div>
          ) : (
            Object.entries(reports.customer_hours)
              .sort(([, a], [, b]) => b - a)
              .map(([customer, hours]) => (
                <div
                  key={customer}
                  className="flex justify-between items-center border-b-2 pb-3"
                  style={{ borderColor: 'rgba(255, 107, 0, 0.3)' }}
                >
                  <div className="text-xl font-semibold" style={{ color: '#ffffff' }}>
                    {customer}
                  </div>
                  <div className="flex items-center gap-4">
                    <div
                      className="h-6"
                      style={{
                        width: `${Math.min(hours * 20, 300)}px`,
                        background: 'linear-gradient(90deg, #FF6B00 0%, #ffffff 100%)',
                        boxShadow: '0 0 10px rgba(255, 107, 0, 0.5)',
                      }}
                    />
                    <div className="text-2xl font-bold w-20 text-right" style={{ color: '#FF6B00' }}>
                      {hours.toFixed(1)}h
                    </div>
                  </div>
                </div>
              ))
          )}
        </div>
      </div>
    </div>
  );
}